import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from '@chakra-ui/react'
import DetailSentence from './DetailSentence'
import DetailPhrase from './DetailPhrase'

interface DetailModalProps {
  isOpen: boolean
  onClose: () => void
  detailKnowledge: any
  handlePlayAudio: (audio: string) => void
  type: string
}

const DetailModal = ({
  isOpen,
  onClose,
  detailKnowledge,
  handlePlayAudio,
  type,
}: DetailModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="full">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          Chi tiết {type === 'SENTENCE' ? 'mẫu câu' : 'cụm từ'}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {type === 'SENTENCE' ? (
            <DetailSentence
              detailKnowledge={detailKnowledge}
              handlePlayAudio={handlePlayAudio}
            />
          ) : (
            <DetailPhrase
              detailKnowledge={detailKnowledge}
              handlePlayAudio={handlePlayAudio}
            />
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default DetailModal
